module.exports = __webpack_public_path__ + "img/password.2b5f1a38.svg";